// src/components/FacturasProfesionales.jsx
import { useMemo, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../assets/LOGO - FOOTER.png";
import "./FacturaView.css"; // reutilizamos estilos de factura

// 🔹 Datos del centro (constantes)
const CENTRO = {
  nombre: "Teresa Hernandez Cardenas",
  direccion: "Avenida Alcalde Jesús Mantaras, local 5",
  localidad: "Jerez de la Frontera, Cádiz 11405",
  telefono: "+34 601 866 199",
  nif: "77172767Q", // lo comentarás / pondrás más adelante
};

const CENTRO1 = {
  nombre: "TE AYUDO",
  direccion: "Avenida Alcalde Jesús Mantaras, local 5",
  localidad: "Jerez de la Frontera, Cádiz 11405",
  telefono: "+34 601 866 199",
  // nif: "X0000000T", // lo comentarás / pondrás más adelante
};

// 🔹 Profesionales por servicio (para facturas y dinámica)
const PROFESIONALES = {
  psicologia: {
    profesional_nombre: "Teresa Hernández Cárdenas",
    profesional_dni: "77172767Q",
    profesional_rol: "Psicóloga Sanitaria",
    profesional_colegiado: "AN12757",
    precio: 200,
  },

  logopedia: {
    profesional_nombre: "Mercedes Gómez Alonso",
    profesional_dni: "32091634X",
    profesional_rol: "Logopeda",
    profesional_colegiado: "29/2981",
    precio: 140,
  },

  yoga: {
    profesional_nombre: "Americo Chiclana Rico",
    profesional_dni: "47541725N",
    profesional_rol: "Instructor de Yoga",
    profesional_colegiado: "",
    precio: 60,
  },

  nutricion: {
    profesional_nombre: "María Erdozain López",
    profesional_dni: "32094105C",
    profesional_rol: "Dietista-Nutricionista",
    profesional_colegiado: "AND01255",
    precio: 100,
  },

  otro: {
    profesional_nombre: "Equipo TeAyudo",
    profesional_dni: "00000000X",
    profesional_rol: "Profesional",
    profesional_colegiado: "",
    precio: "",
  },
};

export default function FacturasProfesionales({
  mes,
  setMes,
  pagosMes,
  loading,
  error,
}) {
  // IVA solo es configurable en la dinámica
  const [aplicaIvaDinamica, setAplicaIvaDinamica] = useState(true);

  // Factura / presupuesto dinámico
  const [dinamica, setDinamica] = useState({
    tipo: "Factura", // "Factura" o "Presupuesto"
    servicio: "",
    nombre: "",
    nif: "",
    concepto: "",
    base: "",
    profesional_nombre: "",
    profesional_dni: "",
    profesional_rol: "",
    profesional_colegiado: "",
    cuenta: "",
    condicionesPago: "",
  });

  // Refs PDF
  const facturaLogopedaRef = useRef();
  const facturaNutricionistaRef = useRef();
  const facturaDinamicaRef = useRef();

  // Helper: convertir mes YYYY-MM a texto “noviembre 2025”
  const mesTexto = useMemo(() => {
    if (!mes) return "";
    const d = new Date(mes + "-01");
    if (Number.isNaN(d.getTime())) return mes;
    return d.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
  }, [mes]);

  // Calcular 30% para logopedia / nutrición a partir de pagosMes
  const calcularComision30 = (items = [], code) => {
    let suma = 0;
    items.forEach((p) => {
      const c = (p.specialty_code || "").toLowerCase();
      if (c === code) {
        suma += Number(p.amount) || 0;
      }
    });
    return suma * 0.3;
  };

  const comisionLogopedia = useMemo(
    () => calcularComision30(pagosMes, "logopeda"),
    [pagosMes]
  );
  const comisionNutricion = useMemo(
    () => calcularComision30(pagosMes, "nutricion"),
    [pagosMes]
  );

  // Calcular IVA y total a partir de base
  const calcularIvaYTotal = (base, aplicaIva = true) => {
    const baseNum = Number(base) || 0;
    const iva = aplicaIva ? baseNum * 0.21 : 0;
    const total = baseNum + iva;
    return { iva, total };
  };

  // Profesionales fijos logopedia/nutrición
  const LOGOPEDA_PRO = PROFESIONALES.logopedia;
  const NUTRICION_PRO = PROFESIONALES.nutricion;

  // Logopedia y nutrición SIN IVA (total = base 30%)
  const totalLogopedia = comisionLogopedia;
  const totalNutricion = comisionNutricion;

  // Dinámica: IVA opcional
  const baseDinamica = Number(dinamica.base) || 0;
  const { iva: ivaDinamica, total: totalDinamica } = calcularIvaYTotal(
    baseDinamica,
    aplicaIvaDinamica
  );

  const handleDownloadPDF = async (ref, fileName) => {
    const input = ref.current;
    if (!input) return;

    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pageWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
    pdf.save(fileName);
  };

  // Conceptos de la factura
  const conceptoLogopedia = `Cuota por colaboración profesional sanitaria, incluyendo uso compartido de espacios y servicios de apoyo a la actividad asistencial, correspondiente al mes de ${mesTexto}. Operación exenta de IVA conforme al artículo 20.Uno.3 de la Ley 37/1992.`;
  const conceptoNutricion = `Cuota por colaboración profesional sanitaria, incluyendo uso compartido de espacios y servicios de apoyo a la actividad asistencial, correspondiente al mes de ${mesTexto}. Operación exenta de IVA conforme al artículo 20.Uno.3 de la Ley 37/1992.`;

  return (
    <div className="cierre-panel facturas-profesionales">
      <div className="pagos-actions">
        <div className="month-filter">
          <label>
            Mes:
            <input
              type="month"
              value={mes}
              onChange={(e) => setMes(e.target.value)}
            />
          </label>
        </div>
      </div>

      {loading ? (
        <p>Cargando datos...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <>
          <h3 className="facturas-title">
            Facturas profesionales mes {mesTexto || mes}
          </h3>

          {/* --- LOGOPEDA (FIJA, SIN INPUTS) --- */}
          <section className="factura-card">
            <div className="factura-card-header">
              <h4>Factura Logopeda</h4>
              <span className="tag tag-logopedia">Logopedia</span>
            </div>

            <div className="factura-resumen">
              <p>
                <strong>Profesional:</strong> {LOGOPEDA_PRO.profesional_nombre}
              </p>
              <p>
                <strong>DNI:</strong> {LOGOPEDA_PRO.profesional_dni}
              </p>
              <p>
                <strong>Rol:</strong> {LOGOPEDA_PRO.profesional_rol}
              </p>
              {LOGOPEDA_PRO.profesional_colegiado && (
                <p>
                  <strong>Nº colegiado:</strong>{" "}
                  {LOGOPEDA_PRO.profesional_colegiado}
                </p>
              )}
              <p>
                <strong>Base 30% logopedia:</strong>{" "}
                {comisionLogopedia.toFixed(2)} €
              </p>
              <p>
                <strong>Total factura:</strong> {totalLogopedia.toFixed(2)} €
              </p>
            </div>

            <button
              className="btn-pdf"
              onClick={() =>
                handleDownloadPDF(
                  facturaLogopedaRef,
                  `factura_logopeda_${mes || "sin_mes"}.pdf`
                )
              }
            >
              📄 Descargar factura logopeda
            </button>

            {/* FACTURA VISUAL LOGOPEDA */}
            <div
              className="factura-container"
              ref={facturaLogopedaRef}
              style={{ marginTop: "1rem" }}
            >
              <header className="factura-header">
                <img src={logo} alt="Te Ayudo" className="factura-logo" />
                <div className="factura-info">
                  <p>{CENTRO.nombre}</p>
                  <p>{CENTRO.direccion}</p>
                  <p>{CENTRO.localidad}</p>
                  <p>Tel: {CENTRO.telefono}</p>
                  {/* <p>NIF: {CENTRO.nif}</p> */}
                </div>
              </header>

              <h2 className="factura-title">Factura</h2>

              <div className="factura-details">
                <p>
                  <strong>Fecha:</strong>{" "}
                  {new Date().toLocaleDateString("es-ES")}
                </p>
                <p>
                  <strong>Destinatario:</strong>{" "}
                  {LOGOPEDA_PRO.profesional_nombre}
                </p>
                <p>
                  <strong>NIF:</strong> {LOGOPEDA_PRO.profesional_dni}
                </p>
                <p>
                  <strong>Rol:</strong> {LOGOPEDA_PRO.profesional_rol}
                </p>
                {LOGOPEDA_PRO.profesional_colegiado && (
                  <p>
                    <strong>Nº colegiado:</strong>{" "}
                    {LOGOPEDA_PRO.profesional_colegiado}
                  </p>
                )}
              </div>

              <table className="factura-table">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th style={{ textAlign: "right" }}>Base (€)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{conceptoLogopedia}</td>
                    <td style={{ textAlign: "right" }}>
                      {comisionLogopedia.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="factura-total">
                Total: {totalLogopedia.toFixed(2)} €
              </div>

              <footer className="factura-footer">
                <p>Factura de servicios profesionales de logopedia</p>
                <p>Número de cuenta: ES80 2100 2545 1902 1042 0805</p>
                <p>
                  El pago tiene que efectuarse entre los días 1 y 5 del mes.
                </p>
              </footer>
            </div>
          </section>

          {/* --- NUTRICIONISTA (FIJA, SIN INPUTS) --- */}
          <section className="factura-card">
            <div className="factura-card-header">
              <h4>Factura Nutricionista</h4>
              <span className="tag tag-nutricion">Nutrición</span>
            </div>

            <div className="factura-resumen">
              <p>
                <strong>Profesional:</strong> {NUTRICION_PRO.profesional_nombre}
              </p>
              <p>
                <strong>DNI:</strong> {NUTRICION_PRO.profesional_dni}
              </p>
              <p>
                <strong>Rol:</strong> {NUTRICION_PRO.profesional_rol}
              </p>
              {NUTRICION_PRO.profesional_colegiado && (
                <p>
                  <strong>Nº colegiado:</strong>{" "}
                  {NUTRICION_PRO.profesional_colegiado}
                </p>
              )}
              <p>
                <strong>Base 30% nutrición:</strong>{" "}
                {comisionNutricion.toFixed(2)} €
              </p>
              <p>
                <strong>Total factura:</strong> {totalNutricion.toFixed(2)} €
              </p>
            </div>

            <button
              className="btn-pdf"
              onClick={() =>
                handleDownloadPDF(
                  facturaNutricionistaRef,
                  `factura_nutricionista_${mes || "sin_mes"}.pdf`
                )
              }
            >
              📄 Descargar factura nutricionista
            </button>

            {/* FACTURA VISUAL NUTRICIONISTA */}
            <div
              className="factura-container"
              ref={facturaNutricionistaRef}
              style={{ marginTop: "1rem" }}
            >
              <header className="factura-header">
                <img src={logo} alt="Te Ayudo" className="factura-logo" />
                <div className="factura-info">
                  <p>{CENTRO.nombre}</p>
                  <p>{CENTRO.direccion}</p>
                  <p>{CENTRO.localidad}</p>
                  <p>Tel: {CENTRO.telefono}</p>
                  {/* <p>NIF: {CENTRO.nif}</p> */}
                </div>
              </header>

              <h2 className="factura-title">Factura</h2>

              <div className="factura-details">
                <p>
                  <strong>Fecha:</strong>{" "}
                  {new Date().toLocaleDateString("es-ES")}
                </p>
                <p>
                  <strong>Destinatario:</strong>{" "}
                  {NUTRICION_PRO.profesional_nombre}
                </p>
                <p>
                  <strong>NIF:</strong> {NUTRICION_PRO.profesional_dni}
                </p>
                <p>
                  <strong>Rol:</strong> {NUTRICION_PRO.profesional_rol}
                </p>
                {NUTRICION_PRO.profesional_colegiado && (
                  <p>
                    <strong>Nº colegiado:</strong>{" "}
                    {NUTRICION_PRO.profesional_colegiado}
                  </p>
                )}
              </div>

              <table className="factura-table">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th style={{ textAlign: "right" }}>Base (€)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{conceptoNutricion}</td>
                    <td style={{ textAlign: "right" }}>
                      {comisionNutricion.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="factura-total">
                Total: {totalNutricion.toFixed(2)} €
              </div>

              <footer className="factura-footer">
                <p>Factura de servicios profesionales de nutrición</p>
                <p>Número de cuenta: ES80 2100 2545 1902 1042 0805</p>
                <p>
                  El pago tiene que efectuarse entre los días 1 y 5 del mes.
                </p>
              </footer>
            </div>
          </section>

          {/* --- FACTURA / PRESUPUESTO DINÁMICO --- */}
          <section className="factura-card">
            <div className="factura-card-header">
              <h4>Factura / Presupuesto personalizado</h4>
              <span className="tag tag-dinamica">
                {dinamica.tipo === "Factura"
                  ? "Otros servicios"
                  : "Presupuesto"}
              </span>
            </div>

            <div className="factura-profesional-form factura-profesional-form--grid">
              <label>
                Tipo:
                <select
                  value={dinamica.tipo}
                  onChange={(e) =>
                    setDinamica((prev) => ({ ...prev, tipo: e.target.value }))
                  }
                >
                  <option value="Factura">Factura</option>
                  <option value="Presupuesto">Presupuesto</option>
                </select>
              </label>

              <label>
                Servicio:
                <select
                  value={dinamica.servicio}
                  onChange={(e) => {
                    const serv = e.target.value;
                    const data = PROFESIONALES[serv] || PROFESIONALES["otro"];

                    setDinamica((prev) => ({
                      ...prev,
                      servicio: serv,
                      profesional_nombre: data.profesional_nombre,
                      profesional_dni: data.profesional_dni,
                      profesional_rol: data.profesional_rol,
                      profesional_colegiado: data.profesional_colegiado,
                      base:
                        prev.base ||
                        (data.precio !== undefined ? data.precio : ""),
                      concepto:
                        prev.concepto ||
                        (serv && serv !== "otro"
                          ? `Servicios profesionales de ${serv}`
                          : prev.concepto),
                    }));
                  }}
                >
                  <option value="">Seleccionar…</option>
                  <option value="psicologia">Psicología</option>
                  <option value="logopedia">Logopedia</option>
                  <option value="nutricion">Nutrición</option>
                  <option value="yoga">Yoga</option>
                  <option value="otro">Otro</option>
                </select>
              </label>

              <label>
                Nombre destinatario:
                <input
                  type="text"
                  value={dinamica.nombre}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      nombre: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                NIF:
                <input
                  type="text"
                  value={dinamica.nif}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      nif: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Concepto:
                <input
                  type="text"
                  value={dinamica.concepto}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      concepto: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Base imponible (€):
                <input
                  type="number"
                  step="0.01"
                  value={dinamica.base}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      base: e.target.value,
                    }))
                  }
                />
              </label>

              <label className="factura-iva-toggle">
                <input
                  type="checkbox"
                  checked={aplicaIvaDinamica}
                  onChange={(e) => setAplicaIvaDinamica(e.target.checked)}
                />
                Aplicar IVA (21%)
              </label>

              {/* Datos del profesional (autocompletados pero editables) */}
              <label>
                Profesional:
                <input
                  type="text"
                  value={dinamica.profesional_nombre}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      profesional_nombre: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                DNI profesional:
                <input
                  type="text"
                  value={dinamica.profesional_dni}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      profesional_dni: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Rol profesional:
                <input
                  type="text"
                  value={dinamica.profesional_rol}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      profesional_rol: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Nº colegiado:
                <input
                  type="text"
                  value={dinamica.profesional_colegiado}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      profesional_colegiado: e.target.value,
                    }))
                  }
                />
              </label>

              <label>
                Número de cuenta:
                <input
                  type="text"
                  value={dinamica.cuenta}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      cuenta: e.target.value,
                    }))
                  }
                  placeholder="ES__ ____ ____ ____ ____ ____"
                />
              </label>

              <label>
                Condiciones de pago:
                <input
                  type="text"
                  value={dinamica.condicionesPago}
                  onChange={(e) =>
                    setDinamica((prev) => ({
                      ...prev,
                      condicionesPago: e.target.value,
                    }))
                  }
                  placeholder="Ej: El pago debe efectuarse entre los días 1 y 5 del mes"
                />
              </label>
            </div>

            <div className="factura-resumen">
              <p>
                <strong>Base:</strong> {baseDinamica.toFixed(2)} €
              </p>
              <p>
                <strong>IVA:</strong>{" "}
                {aplicaIvaDinamica
                  ? `21% - ${ivaDinamica.toFixed(2)} €`
                  : "Exento"}
              </p>
              <p>
                <strong>Total:</strong> {totalDinamica.toFixed(2)} €
              </p>
            </div>

            <button
              className="btn-pdf"
              onClick={() =>
                handleDownloadPDF(
                  facturaDinamicaRef,
                  `${dinamica.tipo.toLowerCase()}_${mes || "sin_mes"}.pdf`
                )
              }
              disabled={baseDinamica <= 0 || !dinamica.concepto}
            >
              📄 Descargar {dinamica.tipo.toLowerCase()}
            </button>

            {/* FACTURA / PRESUPUESTO VISUAL DINÁMICO */}
            <div
              className="factura-container"
              ref={facturaDinamicaRef}
              style={{ marginTop: "1rem" }}
            >
              <header className="factura-header">
                <img src={logo} alt="Te Ayudo" className="factura-logo" />
                <div className="factura-info">
                  <p>{CENTRO1.nombre}</p>
                  <p>{CENTRO1.direccion}</p>
                  <p>{CENTRO1.localidad}</p>
                  <p>Tel: {CENTRO1.telefono}</p>
                  {/* <p>NIF: {CENTRO.nif}</p> */}
                </div>
              </header>

              <h2 className="factura-title">{dinamica.tipo}</h2>

              <div className="factura-details">
                <p>
                  <strong>Fecha:</strong>{" "}
                  {new Date().toLocaleDateString("es-ES")}
                </p>
                {dinamica.nombre && (
                  <p>
                    <strong>Destinatario:</strong> {dinamica.nombre}
                  </p>
                )}
                {dinamica.nif && (
                  <p>
                    <strong>NIF:</strong> {dinamica.nif}
                  </p>
                )}
                {dinamica.profesional_nombre && (
                  <p>
                    <strong>Profesional:</strong> {dinamica.profesional_nombre}
                  </p>
                )}
                {dinamica.profesional_dni && (
                  <p>
                    <strong>DNI profesional:</strong> {dinamica.profesional_dni}
                  </p>
                )}
                {dinamica.profesional_rol && (
                  <p>
                    <strong>Rol profesional:</strong> {dinamica.profesional_rol}
                  </p>
                )}
                {dinamica.profesional_colegiado && (
                  <p>
                    <strong>Nº colegiado:</strong>{" "}
                    {dinamica.profesional_colegiado}
                  </p>
                )}
                {dinamica.concepto && (
                  <p>
                    <strong>Concepto:</strong> {dinamica.concepto}
                  </p>
                )}
              </div>

              <table className="factura-table">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th style={{ textAlign: "right" }}>Base (€)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{dinamica.concepto || "Concepto"}</td>
                    <td style={{ textAlign: "right" }}>
                      {baseDinamica.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {aplicaIvaDinamica ? "IVA (21%)" : "IVA (exento)"}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {ivaDinamica.toFixed(2)} €
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="factura-total">
                Total: {totalDinamica.toFixed(2)} €
              </div>

              <footer className="factura-footer">
                <p>
                  {dinamica.tipo} de servicios profesionales
                  {dinamica.concepto ? ` – ${dinamica.concepto}` : ""}
                </p>
                {dinamica.cuenta && <p>Número de cuenta: {dinamica.cuenta}</p>}
                {dinamica.condicionesPago && <p>{dinamica.condicionesPago}</p>}
              </footer>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
